import React from 'react';
import { Container, Nav, NavItem, NavLink } from 'reactstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import classnames from 'classnames';

const SSPStudioLayout = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const isActive = (path) => {
    if (path === '/ssp-studio' && location.pathname === '/ssp-studio') return true;
    if (path !== '/ssp-studio' && location.pathname.startsWith(path)) return true;
    return false;
  };

  const navItems = [
    { path: '/ssp-studio', icon: 'mdi-view-dashboard', label: 'Dashboard' },
    { path: '/ssp-studio/ssps', icon: 'mdi-file-document', label: 'SSPs' },
    { path: '/ssp-studio/templates', icon: 'mdi-file-document-multiple', label: 'Templates' },
    { path: '/ssp-studio/create', icon: 'mdi-plus-circle', label: 'Create SSP' },
    { path: '/ssp-studio/mappings', icon: 'mdi-table-search', label: 'Mappings' },
    { path: '/ssp-studio/scans', icon: 'mdi-file-upload', label: 'Scans' },
    { path: '/ssp-studio/findings', icon: 'mdi-shield-search', label: 'Findings' },
    { path: '/ssp-studio/evidence', icon: 'mdi-file-document', label: 'Evidence' },
  ];

  return (
    <div className="page-content">
      <Container fluid>
        <Nav tabs className="mb-4">
          {navItems.map((item) => (
            <NavItem key={item.path}>
              <NavLink
                className={classnames({ active: isActive(item.path) })}
                onClick={() => navigate(item.path)}
                style={{ cursor: 'pointer' }}
              >
                <i className={`mdi ${item.icon} me-1`}></i>
                {item.label}
              </NavLink>
            </NavItem>
          ))}
        </Nav>

        {children}
      </Container>
    </div>
  );
};

export default SSPStudioLayout;
